import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { registrationInitialState, registrationReducer } from './registrationReducer';

const RegistrationContext = createContext(null);

export function RegistrationProvider({ children }) {
  const [state, dispatch] = useReducer(
    registrationReducer,
    registrationInitialState,
    (initial) => {
      try {
        const authData = localStorage.getItem('yk_auth');
        if (!authData) return initial;
        const parsed = JSON.parse(authData);
        if (!parsed?.user) return initial;
        return {
          ...initial,
          auth: {
            isAuthenticated: true,
            user: parsed.user
          }
        };
      } catch {
        return initial;
      }
    }
  );

  const value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <RegistrationContext.Provider value={value}>
      {children}
    </RegistrationContext.Provider>
  );
}

export function useRegistration() {
  const ctx = useContext(RegistrationContext);
  if (!ctx) {
    throw new Error('useRegistration must be used within a RegistrationProvider');
  }
  return ctx;
}
